export const DEFAULT_TEXT_SIZE = 'normal';
export const DEFAULT_TEXT_COLOR = 'black';
